<template>
    <canvas ref="grafico" class="grafico"></canvas>
</template>

<script lang="ts">
export default {
    name: 'Bar',
    props:{
        json: Object,
        tipo: String,
    },
    data() {
        grafico: null
    },
    watch:{
        json() {
            this.actualizarDatos();
        },
    },
    mounted() {
        this.crearTable();
        this.actualizarDatos();
    },
    methods: {
        actualizarDatos(){
            if(this.grafico == null){
                this.crearTable();
            }
            let labels = []
            let datos = []

            for(let index in this.json.datos){
                labels.push(this.json.datos[index].titulo);
                datos.push(parseFloat(this.json.datos[index].valor));
            }

            this.grafico.data = {
                labels: labels,
                datasets: [{
                    data: datos,
                    borderWidth: 1,
                    borderRadius: 4,
                    borderSkipped: false,
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.8)',
                        'rgba(255, 159, 64, 0.8)',
                        'rgba(255, 205, 86, 0.8)',
                        'rgba(75, 192, 192, 0.8)',
                        'rgba(54, 162, 235, 0.8)',
                        'rgba(153, 102, 255, 0.8)',
                        'rgba(201, 203, 207, 0.8)'
                    ],
                    borderColor: [
                        'rgb(255, 99, 132)',
                        'rgb(255, 159, 64)',
                        'rgb(255, 205, 86)',
                        'rgb(75, 192, 192)',
                        'rgb(54, 162, 235)',
                        'rgb(153, 102, 255)',
                        'rgb(201, 203, 207)'
                    ],
                }]
            }

            this.grafico.options.scales = {
                y: {
                    max: this.json.max,
                    min: this.json.min
                },
            }

            this.grafico.update();
        },
        crearTable(){

            if(this.grafico == null){

                let params = {
                    type: this.tipo,
                    options: {
                        responsive: true,
                        maintainAspectRatio: true,
                        aspectRatio: 0,
                        plugins: {
                            legend: {
                                display: this.tipo == "pie",
                                position: 'top',
                            }
                        },
                        layout: {
                            padding: {
                                bottom: 20  // Añade espacio en la parte inferior del gráfico
                            }
                        }
                    }
                }

                if(this.tipo != "pie"){
                    params.options.scales = {
                        y: {
                            max: this.json.max,
                            min: this.json.min
                        },
                    }
                }
                else{
                    params.plugins = [{
                        beforeInit: function (chart) {
                            // Get reference to the original fit function
                            const originalFit = chart.legend.fit

                            // Override the fit function
                            chart.legend.fit = function fit() {
                                // Bind scope in order to use `this` correctly inside it
                                originalFit.bind(chart.legend)()
                                this.height += 35 // Change the height
                            }
                        }
                    },
                        {
                            id: 'permanentTooltip',
                            afterDraw: (chart) => {
                                const { ctx, data } = chart;
                                var total = 0
                                if(data.datasets.length > 0){
                                    total = data.datasets[0].data.reduce((sum, value) => sum + value, 0);
                                }

                                chart.data.datasets.forEach((dataset, datasetIndex) => {
                                    chart.getDatasetMeta(datasetIndex).data.forEach((datapoint, index) => {
                                        const { x, y } = datapoint.tooltipPosition();
                                        const value = dataset.data[index];
                                        const label = data.labels[index];

                                        if(value > 0){
                                            var percentage = ((value / total) * 100)
                                            var texto = percentage.toFixed(1)
                                            if (Number.isInteger(percentage)) {
                                                texto = percentage.toFixed(0)
                                            }
                                            ctx.save();
                                            ctx.font = '20px Arial';
                                            ctx.fillStyle = 'white';
                                            ctx.textAlign = 'center';
                                            ctx.textBaseline = 'middle';

                                            // Draw tooltip
                                            ctx.fillText(texto + "%", x, y);
                                            ctx.restore();
                                        }

                                    });
                                });
                            }
                        }
                    ]
                    // params.plugins = [];
                }


                this.grafico = new Chart(this.$refs.grafico, params);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
canvas{
    padding: 25px;
    height: 500px !important;
    @media all and (max-width: 1250px) {
        height: 550px !important;
    }
    @media all and (max-width: 500px) {
        height: 450px !important;
    }
    @media all and (max-width: 400px) {
        height: 350px !important;
    }
}
</style>
